import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  currentLegalVersion,
  lazyLegalModules,
  loadCurrentLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/dpa/*.md"))

export const Route = createFileRoute("/_content/dpa/")({
  head: () =>
    seoMeta({
      title: "Data Processing Agreement",
      description: "How Entire processes personal data on your behalf as a processor.",
      url: "https://entire.com/dpa",
      image: "https://entire.com/og/page/dpa.png",
    }),
  loader: () => loadCurrentLegalVersion(modules),
  component: DpaPage,
})

function DpaPage() {
  const { asOf } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const current = currentLegalVersion(versions)!
  return <LegalVersionPage basePath="/dpa" version={current} versions={versions} />
}
